import * as consts from 'consts/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import {
  useIsPromotionPacketAdmin,
  useIsSuperAdminNonImpersonating,
} from 'utils/models/User';
import { useFeatures } from 'utils/util/features';
import Page from '../Layout/Pages/Page';
import { AdministrationTab } from './administrationTabs';
import { PromotionPacketQuestionsPage } from './ContentAdministration/TemplatesAdmin';
import OrganizationAudit, {
  AuditEntryType,
} from './PeopleAdministration/Audit/OrganizationAudit';

const PromotionPacketsAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();
  const { isEnabled, isGroupAndOptionEnabled } = useFeatures();
  const isPromotionPacketAdmin = useIsPromotionPacketAdmin();
  const isSuperAdmin = useIsSuperAdminNonImpersonating();

  const tabs: AdministrationTab[] = [];

  // the section only holds templates and their audit trail, so it follows
  // the templates flag
  if (
    isEnabled('promotion_packets') &&
    isGroupAndOptionEnabled('content_administration', 'templates_enabled') &&
    (isPromotionPacketAdmin || isSuperAdmin)
  ) {
    tabs.push({
      // first tab, so it also answers the section's base path
      path: consts.ADMINISTRATION_PROMOTION_PACKETS_SETTINGS(formatMessage)
        .path,
      paths: [
        consts.ADMINISTRATION_PROMOTION_PACKETS(formatMessage).path,
        consts.ADMINISTRATION_PROMOTION_PACKETS_SETTINGS(formatMessage).path,
      ],
      name: consts.ADMINISTRATION_PROMOTION_PACKETS_SETTINGS(formatMessage)
        .name,
      // the promotion packet page has its own contextual create buttons
      content: <PromotionPacketQuestionsPage />,
    });

    tabs.push({
      path: consts.ADMINISTRATION_PROMOTION_PACKETS_AUDIT(formatMessage).path,
      name: consts.ADMINISTRATION_PROMOTION_PACKETS_AUDIT(formatMessage).name,
      content: (
        <OrganizationAudit
          auditEntryTypes={[AuditEntryType.PROMOTION_PACKET_MANAGEMENT]}
        />
      ),
    });
  }

  return (
    <Page
      title={consts.ADMINISTRATION_PROMOTION_PACKETS(formatMessage).name}
      forceShowTabs={true}
      tabs={tabs}
    />
  );
};

export default React.memo(PromotionPacketsAdministrationPage);
